const keys = Object.freeze({
  authSession: 'authSession',
  debug: 'debugSimplifi', // local copy of LD 'debug'
  disableBugsnag: 'disableBugsnag',
  entitlements: 'entitlements',
  featureFlagsFreeze: 'featureFlagsFreeze',
  getSessionStorage: 'getSessionStorage', // fake record to trigger 'storage' event = request existing sessionStorage from other tabs
  ignoreBugsnagReport: 'ignoreBugsnagReport',
  keepLoggedIn: 'keepLoggedIn',
  lastSession: 'lastSession',
  mcpTestMode: 'mcpTestMode',
  mobileWarningShown: 'mobileWarning',
  offlineSupport: 'offlineSupport',
  persist: 'persist', // local copy of LD 'persist'
  persistOverride: 'persistOverride', // local override for LD 'persist'
  pollDataset: 'pollDataset',
  selectorsProfiling: 'selectorsProfiling',
  sessionState: 'sessionState',
  sessionStorage: 'sessionStorage', // fake tmp record to trigger 'storage' event = send current sessionStorage to other tabs
  suppressAssertPopups: 'suppressAssertPopups',
  suppressWindowError: 'suppressWindowError',
  wdyrSettings: 'wdyrSettings',
  whyDidYouRender: 'whyDidYouRender',
  logoutReason: 'logoutReason',
  browserWarningShown: 'browserWarningShown',
  persistPurgeVersion: 'persistPurgeVersion',
  mobileAppOS: 'mobileAppOS',
  mobileAppVersion: 'mobileAppVersion',
  mobileBuildNumber: 'mobileBuildNumber',

  // ^^^ add your new preferences above
});

export default keys;
